import { clearChunkReloadFlag, getChunkLoadCause, tryReloadForStaleChunk } from '@Sage/ssm-utils';

import { notifyBugsnagError } from 'BugSnagWrapper';

const unwrapChunkError = (error) => error?.originalError || error;

/**
 * Attempt one-shot reload for post-deploy stale chunk hashes.
 * @returns {boolean} true when a reload was triggered (skip residual UI / notify)
 */
export const attemptStaleChunkSelfHeal = (error) => tryReloadForStaleChunk(unwrapChunkError(error));

/**
 * Residual path after self-heal is exhausted or not applicable: clear guard + Bugsnag tag.
 */
export const reportExhaustedChunkFailure = (error) => {
    clearChunkReloadFlag();
    const original = unwrapChunkError(error);
    notifyBugsnagError(original, {
        chunkLoad: true,
        cause: getChunkLoadCause(original) || getChunkLoadCause(error) || 'unknown',
        selfHealExhausted: true,
    });
};
